export default {
  plant: '仓库',
  major: '装箱单号',
  majorSerialNo: '装箱单号-箱序列号',
  dn: 'DN',
  cartonNo: '箱号',
  giDate: 'GI 时间',
  pe: 'PE',
  productCode: '产品型号',
  sku: 'SKU',
  dc: 'DC',
  size: '产品尺码',
  giQty: '装箱单数量',
  scannedEpcQty: 'EPC 数量',
  serialNoOfCtn: '箱序列号',
  client: '客户名称',
  city: '城市',
  carrierVendorCode: '运输公司代码',
  lastScannedDate: '最后扫描时间',
  actualWeight: '实际重量',
  factoryCode: '工厂代码',
  epc: 'EPC',
  epcDetail: 'EPC 明细',
  searchOptionError: '装箱单号、装箱单号-箱序列号、DN、箱号 或 GI 时间五者至少填一项!',
  maxInputError: '最多支持输入 50 个值。',
  giDateOnlyRangeError: '仅选择 GI 时间时，查询范围最多为 1 周。'
}
